import NotFoundPage from './NotFoundPage.page';

export default NotFoundPage;